import { RouterView } from 'vue-router';
import type { RouteRecordRaw } from 'vue-router';

export const routes: RouteRecordRaw[] = [
  {
    path: 'rules-engine',
    component: RouterView,
    meta: {
      layoutFeatures: {
        actionPanel: true,
      },
    },
    children: [
      {
        path: '',
        component: () => import('@/app/modules/rules-engine/views/rules-engine-table.vue'),
        meta: {
          layoutFeatures: {
            actionPanelVariant: 'module-header',
            pageControlsTarget: 'end',
            pageControlsShowQuickFilters: true,
            pageControlsQuickFiltersLayout: 'stacked',
            pageControlsVisibilityPlacement: 'action-panel',
          },
        },
      },
      {
        path: 'new',
        component: () => import('@/app/modules/rules-engine/views/rules-engine-create.vue'),
        meta: {
          layoutFeatures: {
            actionPanelVariant: 'module-header',
            pageControlsTarget: 'end',
          },
        },
      },
      {
        path: ':ruleId',
        component: () => import('@/app/modules/rules-engine/views/rules-engine-detail.vue'),
        meta: {
          layoutFeatures: {
            actionPanelVariant: 'module-header',
            pageControlsTarget: 'end',
          },
        },
      },
    ],
  },
];

export default routes;
